import * as m from 'mithril';
import CustomSvgIcon from '../../components/CustomSvgIcon';
import { LocationDTO } from '../../apiclient/ApiDtos';

interface Attrs {
    currentLang: string,
    locations: LocationDTO[],
    onLocationSelected: (location:LocationDTO) => void
}

//const notMyanmarSyllablesRegex = /[^\u1000-\u1021]/g;
const anyMyanmarCharacterRegex = /[\u1000-\u103F]/;
const anyMyanamrTonalDecoRegex = /[\u1036-\u1038]/g;

function LocationFilterList() : m.Component<Attrs> {  
    let locations:LocationDTO[] = [];

    let filterText = "";
    let filterLocations:LocationDTO[] = [];
    
    let updateFilterText = function(value:string) {
        filterText = value;
        if(filterText) {
            let filterRegex = new RegExp(filterText.replace(/\s/g, ""), "i");
            
            let myanmarFilterRegex:RegExp|null = null;
            if(anyMyanmarCharacterRegex.test(filterText)) {
                myanmarFilterRegex = new RegExp(filterText.replace(anyMyanamrTonalDecoRegex, ""), "i");
            }

            let matchingLocations:{location:LocationDTO, matchingIndex:number}[] = locations.flatMap(
                location => {
                    let enMatch = filterRegex.exec(location.name.en);
                    if(enMatch) {
                        return [{
                            location: location,
                            matchingIndex: enMatch.index
                        }];
                    } else {
                        let myMatch = filterRegex.exec(location.name.my);
                        if(myMatch) {
                            return [{
                                location: location,
                                matchingIndex: myMatch.index
                            }];
                        } else {
                            // attempt to match without ending decorators in myanmar language
                            if(myanmarFilterRegex) {
                                let myMatch = myanmarFilterRegex.exec(location.name.my.replace(anyMyanamrTonalDecoRegex, ""))
                                if(myMatch) {
                                    return [{
                                        location: location,
                                        matchingIndex: myMatch.index + locations.length
                                    }];
                                }
                            }
                        }
                        return [];
                    }
                }
            );           
                      

            filterLocations = matchingLocations
                .sort((a,b) => a.matchingIndex - b.matchingIndex)
                .map(it => it.location);
        } else {
            filterLocations = locations;
        }
        
    };

    return {
        oncreate(vnode) {
            let elem = document.getElementById("location-filter-input");
            if(elem != null) {
                elem.focus();
            }                        
        },

        oninit(vnode) {
            locations = vnode.attrs.locations;
            filterLocations = vnode.attrs.locations;
        },

        view(vnode) {            
            return m("div", [
                m("div", {class:"form-group"},[
                    m("div", {
                            class:"bg-white p-3 sticky-top shadow-sm"
                        },                    
                        m("input", {
                            id:"location-filter-input",
                            type:"text",
                            class: "form-control",
                            placeholder:"Search...",
                            autocomplete:"off",
                            oninput : function(event) {
                                updateFilterText(event.target.value);
                            }
                        }),
                    ),

                    m("div", {class:"list-group list-group-flush px-0"}, [
                        filterLocations.map(function(location) {                            
                            return m("a", {
                                class:"list-group-item list-group-item-action text-my",
                                href:"#",
                                onclick : function(event) {
                                    event.preventDefault();           
                                    vnode.attrs.onLocationSelected(location);                         
                                }
                            }, [
                                    m("div", {class:"row"}, [
                                        m("div", {class:"col-10"},
                                            (vnode.attrs.currentLang == 'en')?
                                            [m("span.mr-1", {}, location.name.en), m("small.text-muted", {}, " (" + location.name.my + ")")]:
                                            [m("span.mr-1", {}, location.name.my), m("small.text-muted", {}, " (" + location.name.en + ")")]
                                        ),
                                        m("div", {class:"col-2 text-right"}, 
                                            m(CustomSvgIcon, {
                                                iconType: 'keyboard_arrow_right',
                                                themeCssClass: "svg-small svg-muted stroke-muted"
                                            })
                                        )
                                    ])        
                            ]) 
                        }),
                        (filterLocations.length == 0)?
                        m("div.list-group-item list-group-item-action", [
                            m("div.m-1", 
                                m("div", `No result found for "${filterText}".`)
                            )
                        ]) : null
                    ])
                ]
            )
            ])
        }
    }
}


export default LocationFilterList;
